import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireGameEnabled } from '@/lib/route-guards';

/**
 * Layout route existing only to keep every daily reveal page unreachable on a client that
 * didn't deploy it. Sitting at the folder root means pages added under it inherit the check.
 */
export const Route = createFileRoute('/dashboard/daily-reveal')({
  beforeLoad: () => requireGameEnabled('dailyReveal'),
  component: () => <Outlet />,
});
